import { FC, ReactNode, createContext, useMemo } from "react";
import { WebsocketClient } from "@finbackoffice/websocket-client";

export type IWebsocketContext = {
    socketClient: WebsocketClient | null;
    token: string;
    connected: boolean;
    debug: boolean;
};

export const WebsocketContext = createContext<IWebsocketContext>(null as any);

export const WebsocketProvider: FC<{
    socketClient: WebsocketClient | null;
    token: string;
    connected: boolean;
    debug?: boolean;
    children?: ReactNode;
}> = ({ socketClient, token, connected, children, debug }) => {
    const value = useMemo(
        () => ({ socketClient, token, connected, debug: !!debug }),
        [socketClient, token, connected, debug],
    );

    return <WebsocketContext.Provider value={value}>{children}</WebsocketContext.Provider>;
};
